import * as React from 'react';
/**
 * GridPageLayout is shorthand for:
 *     <Grid>
 *         <GridRow>
 *             <GridCol span={12}>
 *                 {children}
 *             </GridCol>
 *         </GridRow>
 *     </Grid>
 */
export function GridPageLayout({ children }) {
    return React.createElement("div", { className: "grid grid-page-layout" }, children);
}
//# sourceMappingURL=component.js.map